import { Component, Input } from '@angular/core';
import { Utils } from '../utils/utils';

export enum LookupTarget {
  Lookup,
  Landing
}

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: []
})
export class LogoComponent {

  lookupTarget = LookupTarget;

  @Input() class: string = "h-12 fill-primary-brand";
  @Input() target: LookupTarget = LookupTarget.Lookup;
  
  get link(): string {
    return this.target === LookupTarget.Lookup ? "/" : Utils.landingPageUrl;
  }
}
